import { Badge } from '@shopify/polaris';
import React, { useMemo } from 'react';

const PlanBadge = ({ plan }) => {
	const status = useMemo(() => {
		if (plan == 'starter') return 'info';
		if (plan == 'growth') return 'success';
		if (plan == 'pro') return 'attention';
		return 'new';
	}, [plan]);

	return <Badge status={status}>{plan.toUpperCase()}</Badge>;
};

export default PlanBadge;
